const formations = [
    {
        id: 1,
        type: "learn",
        nom: "J3UP",
        code: "J3UP",
        date: "9-8-2024",
        score: 100,
        timer: "95h",
        etat: "Fini",
        iteration: 80,
        stages: [
            {
                id: 1,
                nom: "Vérification ",
                erreursTotal: 86,
                steps: [

                    { id: 1, description: "- Tape Black", fait: true, erreurs: 2, timer: 300 },
                    { id: 2, description: "- Tape Red", fait: true, erreurs: 3, timer: 234 },
                    { id: 3, description: "- J3UP 1", fait: true, erreurs: 3, timer: 544 },
                    { id: 4, description: "- J3UP 2", fait: true, erreurs: 2, timer: 123 },
                    { id: 5, description: "- J3UP 3", fait: true, erreurs: 1, timer: 154 },
                    { id: 6, description: "- J3UP 4", fait: true, erreurs: 0, timer: 654 },
                    { id: 7, description: "- Frette Bag 1", fait: true, erreurs: 8, timer: 764 },
                    { id: 8, description: "- Frette Bag 2", fait: true, erreurs: 2, timer: 323 },
                    { id: 9, description: "- Frette Bag 3", fait: true, erreurs: 0, timer: 423 },
                    { id: 10, description: "- ManchonBag", fait: true, erreurs: 2, timer: 876 },
                    { id: 11, description: "- GreaseSmall", fait: true, erreurs: 1, timer: 444 },
                    { id: 12, description: "- GreaseLarge 1", fait: true, erreurs: 3, timer: 975 },
                    { id: 13, description: "- GreaseLarge 2", fait: true, erreurs: 2, timer: 436 },
                    { id: 14, description: "- GreaseLarge 3", fait: true, erreurs: 1, timer: 534 },
                    { id: 15, description: "- MasticSmallBag 1", fait: true, erreurs: 7, timer: 456 },
                    { id: 16, description: "- MasticSmallBag 2", fait: true, erreurs: 5, timer: 234 },
                    { id: 17, description: "- MasticSmallBag 3", fait: true, erreurs: 0, timer: 654 },
                    { id: 18, description: "- MasticLargeBag 1", fait: true, erreurs: 4, timer: 233 },
                    { id: 19, description: "- MasticLargeBag 2", fait: true, erreurs: 2, timer: 444 },
                    { id: 20, description: "- MasticLargeBag 3", fait: true, erreurs: 0, timer: 653 },
                    { id: 21, description: "- PlaqueSemiConductrice", fait: true, erreurs: 2, timer: 356 },
                    { id: 22, description: "- GloveBag", fait: true, erreurs: 1, timer: 907 },
                    { id: 23, description: "- PriseEcranV2c 1", fait: true, erreurs: 9, timer: 172 },
                    { id: 24, description: "- PriseEcranV2c 2", fait: true, erreurs: 5, timer: 456 },
                    { id: 25, description: "- PriseEcranV2c 3", fait: true, erreurs: 2, timer: 434 },
                    { id: 26, description: "- PriseEcranV2c 4", fait: true, erreurs: 2, timer: 344 },
                    { id: 27, description: "- PriseEcranV2c 5", fait: true, erreurs: 0, timer: 763 },
                ],
            },
            {
                id: 2,
                nom: "Vérification test",
                erreursTotal: 63,
                steps: [
                    { id: 1, description: "Stage Scotch Pos ", fait: true, erreurs: 2, timer: 300 },
                    { id: 2, description: "Stage Placement des prises écrans", fait: true },
                    { id: 3, description: "Stage Serrage des prises écran", fait: true },
                    { id: 4, description: "Stage Positionnement des frettes", fait: true },
                    { id: 5, description: "Stage Serrage des frettes", fait: true },
                    { id: 6, description: "Stage Scotch (A/R)", fait: true },
                    { id: 7, description: "Stage Repli des tresses", fait: true },
                    { id: 8, description: "Stage Scotch de maintien des tresses", fait: true },
                    { id: 9, description: "Stage Scotch protect ames", fait: true },
                    { id: 10, description: "Stage Enfilage Monobloc", fait: true },
                    { id: 11, description: "Stage Retrait scotch protecteur", fait: true },
                    { id: 12, description: "Stage Raccord Mécanique (Préparation)", fait: true },
                    { id: 13, description: "Stage Raccord Mécanique (Positionnement)", fait: true },
                    { id: 14, description: "Stage Raccord Mécanique (Fixation)", fait: true },
                    { id: 15, description: "Stage Scotch semi-conducteur", fait: true },
                    { id: 16, description: "Stage Mastic", fait: true },
                    { id: 17, description: "Stage Plaque SC", fait: true },
                    { id: 18, description: "Stage Serrage main plaque SC", fait: true },
                    { id: 19, description: "Stage Graissage du câble", fait: true },
                    { id: 20, description: "Stage Scotch housse J3UP", fait: true },
                    { id: 21, description: "Stage Retrait housse protection", fait: true },
                    { id: 22, description: "Stage Fixation tresse", fait: true },
                    { id: 23, description: "Stage Retrait scotch tube", fait: true },
                    { id: 24, description: "Stage J3UP morph", fait: true },
                    { id: 25, description: "Stage Retrait fixation tresse", fait: true },
                    { id: 26, description: "Stage Retrait scotch tube tresse", fait: true },
                    { id: 27, description: "Stage J3UP morph part2", fait: true },
                    { id: 28, description: "Stage Serrage colliers nylon", fait: true },
                    { id: 29, description: "Fin", fait: true },



                ],
            },
            {
                id: 3,
                nom: "Formation",
                erreursTotal: 120,
                steps: [
                    { id: 1, description: "Step1 (Actionnez le loquet)", fait: true },
                    { id: 2, description: "Step2 (Enlever les vis du câche", fait: false },
                    { id: 3, description: "Step3 (Enlever le cache)", fait: false },
                    { id: 4, description: "Step4 (Retirez le câche)", fait: false },
                ],
            },
            {
                id: 4,
                nom: "Formation test",
                erreursTotal: 12,
                steps: [
                    { id: 1, description: "Step6 (Déconnecter le câble d'alimentation du ventilateur)", fait: false },
                    { id: 2, description: "Step7 Retirer les vis de fixations", fait: false },
                    { id: 3, description: "Step8 (Extraire le ventilateur)", fait: false },
                    { id: 4, description: "Step9 (Nettoyage du ventilateur)", fait: false },
                    { id: 5, description: "Step10 (Nettoyer le compartiment)", fait: false },
                    { id: 6, description: "Step11 (Utiliser le spray)", fait: false },
                    { id: 7, description: "Step12 (Nettoyer les deux cotés du ventilateur)", fait: false },
                    { id: 8, description: "Step13 Vérifier les ailettes", fait: false },


                ],
            },
            {
                id: 5,
                nom: "Spécial",
                erreursTotal: 49,
                steps: [
                    { id: 1, description: "Step6 (Déconnecter le câble d'alimentation du ventilateur)", fait: false },
                    { id: 2, description: "Step7 Retirer les vis de fixations", fait: false },
                    { id: 3, description: "Step8 (Extraire le ventilateur)", fait: false },
                    { id: 4, description: "Step9 (Nettoyage du ventilateur)", fait: false },
                    { id: 5, description: "Step10 (Nettoyer le compartiment)", fait: false },
                    { id: 6, description: "Step11 (Utiliser le spray)", fait: false },
                    { id: 7, description: "Step12 (Nettoyer les deux cotés du ventilateur)", fait: false },
                    { id: 8, description: "Step13 Vérifier les ailettes", fait: false },


                ],
            },
        ],
    },

    {
        id: 2,
        type: "exam",
        nom: "CSE/CSD ",
        code: "CSE/CSD",
        date: "10-10-2024",
        score: 49,
        timer: "5h",
        etat: "Fini",
        iteration: 20,
        stages: [

        ],
    },
    {
        id: 3,
        type: "exam",
        nom: "K480 ",
        code: "K480",
        date: "12-1-2025",
        score: 69,
        timer: "5h",
        etat: "Fini",
        iteration: 40,
        stages: [

        ],
    },


];

export default formations;
